var _path, _rect;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownBtArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64654 9.41604C7.36129 9.13215 6.8988 9.13215 6.61355 9.41604C6.3283 9.69992 6.3283 10.1602 6.61355 10.4441L11.4831 15.2902C11.7684 15.5741 12.2309 15.5741 12.5161 15.2902L17.3857 10.4441C17.6709 10.1602 17.6709 9.69992 17.3857 9.41604C17.1004 9.13215 16.6379 9.13215 16.3527 9.41604L11.9996 13.7482L7.64654 9.41604Z",
    fill: "#003f2d"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "#003f2d",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownBtArrow);
export default __webpack_public_path__ + "static/media/down-bt-arrow.a46f3f0e858891ecd82783413da6a7fc.svg";
export { ForwardRef as ReactComponent };